import React from 'react';
import { multilanguage } from "redux-multilanguage";

import './NotFound.scss';

function NotFound(props) {
  let { strings } = props;
  return (
    <div className="notFoundScreen">
      <div className="cardBox">
        <div className="title">{strings["404"]}</div>
        <div className="sub-title">{strings["WHOOPS"]}</div>
        <div className="txt">{strings["NOTFOUND"]}</div>
      </div>
    </div>
  );
}

export default (multilanguage(NotFound));